import React, { useRef, useMemo } from "react"
import { useParams, useLocation } from "react-router"

import Title from '@base/Title'
import Toast from '@base/Toast'

import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"

import { ProcessoResolver } from "@helpers/ProcessoHelper"

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export const ListagemCartoesIntrusos = () => {
  const params = useParams();
  const processo = ProcessoResolver(params.processo);
  const toastRef = useRef(null)
  const query = useQuery();

  const columns = [
    { label: 'Caixa', name: 'caixa', key: false, ordering: false },
    { label: 'Caixa da Escola', name: 'caixaEscola', key: false, ordering: false }
  ];

  return (
    <>
      <Toast ref={toastRef} />
      <Title>Listagem de Cartões Intrusos</Title>
      <br />

      <CartoesTableView
        filtroCaixa={query.get("caixa")}
        filtroCartaoEmCaixaDiferenteDaEscola={true}
        processo={processo.id}
        colunasAdicionais={columns}
        permiteMoverCartaoParaCaixaDaEscola={true}
      />
    </>
  );
}

export default ListagemCartoesIntrusos;
